import { render } from "./ScatterPlotForm.vue?vue&type=template&id=cf56be3c"
import script from "./ScatterPlotForm.vue?vue&type=script&lang=js"
export * from "./ScatterPlotForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__